export default __webpack_public_path__ + "static/media/cc.ce190713.svg";